import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	text-align: center;
	color: ${CSSVars.black};

	.hero-wrapper {
		background: url(/assets/hero-bg.webp);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: center 0%;
		color: ${CSSVars.white};
		
		.inner-wrapper {
			padding: 80px 20px 50px;
			@media screen and (min-width: ${CSSVars.breakpointLG}) {
				padding: 130px 40px 100px;
			}

			h1 {
				margin: 0 auto;
				font-size: ${CSSVars.fontSize2XL};
				max-width: 1100px;
				margin-bottom: 20px;

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					font-size: ${CSSVars.fontSize3XL};
				}
			}

			h2 {
				margin: 0 auto;
				font-size: ${CSSVars.fontSizeLG};
				max-width: 780px;
				font-weight: 300;

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					font-size: ${CSSVars.fontSizeXL};
				}
			}

			a.try-button {
				padding: 12px 20px;
				font-size: ${CSSVars.fontSizeMD};
				margin: 30px auto 0;
				background-color: ${CSSVars.white};
				color: ${CSSVars.blue};
				font-weight: 500;

				&:hover {
					background-color: ${CSSVars.white};
					color: ${CSSVars.blue};
					opacity: 0.8;
				}

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					margin: 50px auto 0;
				}
			}
		}
	}

	.referrals-section {
		padding: 50px 20px;

		@media screen and (min-width: ${CSSVars.breakpointLG}) {
			padding: 100px 40px;
		}

		h2 {
			display: block;
			font-size: ${CSSVars.fontSize2XL};
			margin:0 auto  50px;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				max-width: unset;
			}

			span {
				display: inline-block;
				font-weight: 700;
				margin: 0 10px;
				color: ${CSSVars.blue};
			}
		}

		.referrals {
			max-width: 950px;
			margin: 0 auto;

			.referral {
				display: grid;
				margin-bottom: 30px;
				grid-gap: 15px;
				grid-template-columns: 1fr 1fr 1fr;

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					grid-template-columns: 215px 2fr 1fr;
					grid-gap: 50px;
					margin-bottom: 50px;
				}

				&:last-child {
					margin: 0;
				}

				p {
					font-size: ${CSSVars.fontSizeSM};
					font-weight: 300;
					margin: 0;
					text-align: left;

					@media screen and (min-width: ${CSSVars.breakpointMD}) {
						font-size: ${CSSVars.fontSizeMD};
						text-align: right;
					}

					@media screen and (min-width: ${CSSVars.breakpointLG}) {
						font-size: ${CSSVars.fontSizeLG};
					}

					&:last-child {
						text-align: right;

						@media screen and (min-width: ${CSSVars.breakpointLG}) {
							text-align: left;
						}
					}
				}
			}
		}
	}

	.slider {
		position: relative;
		height: fit-content;

		.track {
			position: absolute;
			background-color: ${CSSVars.gray50};
			left: 0;
			bottom: 9px;
			width: 100%;
			border-radius: 20px;
			z-index: 1;
			height: 7px;
		}

		.trail {
			position: absolute;
			background: ${CSSVars.pink};
			left: 0;
			bottom: 9px;
			border-radius: 20px;
			z-index: 2;
			height: 7px;
		}
	}

	.affiliate-progress {
		z-index: 22;
		position: relative;
		background: transparent;
		border: none;
		border-radius: 8px;
		height: 7px;
		width: calc(100%);
		-webkit-appearance: none;
		padding: 0;

		outline: none;
		transition: background 450ms ease-in;
		-webkit-appearance: none;

		&::-webkit-slider-thumb {
			width: 18px;
			height: 18px;
			z-index: 12;
			border-radius: 50%;
			margin-top: -4px;
			-webkit-appearance: none;
			cursor: ew-resize;
			border: 2px solid ${CSSVars.white};
			background: ${CSSVars.pink};
		}
	}
`;
